import { createFileRoute, redirect } from '@tanstack/react-router';
import { CheckInbox } from '@features/eor/CheckInbox';

export const Route = createFileRoute('/eor/check-inbox')({
  validateSearch: (s: Record<string, unknown>): { email: string; challengeId: string; cd: number } => ({
    email: typeof s.email === 'string' ? s.email : '',
    challengeId: typeof s.challengeId === 'string' ? s.challengeId : '',
    cd: typeof s.cd === 'number' ? s.cd : 0,
  }),
  beforeLoad: ({ search }) => {
    if (!search.challengeId) throw redirect({ to: '/eor/find' });
  },
  component: CheckInbox,
});
